/**
 * Global application configuration.
 * Can store run-time options, API urls, paths, execution flags and so on.
 * Automatically loaded on application initialization and available as app.config.
 */

'use strict';

// public
module.exports = {
    httpServer: {
        url: 'http://37.58.57.240',
        port: '1488'
    },
    webSocket: {
        uri: null,
        port: null
    },
    user: {
        id: null
    },
    /**
     * Flag to use long polling instead websockets
     */
    forceLongPolling: false
};
